import { useState, useEffect } from 'react'
import { Table, Card, Tag, Button, Space, message, Modal, Tabs } from 'antd'
import { AuditOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons'
import axios from 'axios'

const LeaveRequests = () => {
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [activeTab, setActiveTab] = useState('pending')
  const [stats, setStats] = useState({ total: 0, pending: 0, passed: 0, rejected: 0 })

  const getToken = () => localStorage.getItem('accessToken') || localStorage.getItem('token') || ''
  const getUser = () => {
    const u = localStorage.getItem('user')
    return u ? JSON.parse(u) : {}
  }

  // 加载统计数据
  const loadStats = async () => {
    try {
      const user = getUser()
      const res = await axios.get('/api/approval/stats', {
        headers: { Authorization: `Bearer ${getToken()}` },
        params: { userId: user.id || 1 }
      })
      if (res.data.code === 0) {
        setStats(res.data.data || { total: 0, pending: 0, passed: 0, rejected: 0 })
      }
    } catch (e) {}
  }

  // 加载请假列表（type=1 为请假）
  const loadList = async () => {
    setLoading(true)
    try {
      const user = getUser()
      const params: any = { userId: user.id || 1, type: 1 }
      if (activeTab === 'pending') params.status = 0
      else if (activeTab === 'approved') params.status = 1
      else if (activeTab === 'rejected') params.status = 2
      
      const res = await axios.get('/api/approval/my-requests', {
        headers: { Authorization: `Bearer ${getToken()}` },
        params
      })
      if (res.data.code === 0) {
        setList(res.data.data?.list || [])
      }
    } catch (err) {
      message.error('加载请假记录失败')
    }
    setLoading(false)
  }

  useEffect(() => {
    loadStats()
    loadList()
  }, [activeTab])

  const handleReview = async (id: number, status: number) => {
    try {
      const user = getUser()
      const res = await axios.post(`/api/approval/requests/${id}/review`, {
        approver_id: user.id || 1,
        status,
      }, {
        headers: { Authorization: `Bearer ${getToken()}` }
      })
      if (res.data.code === 0) {
        message.success(status === 1 ? '已批准' : '已拒绝')
        loadStats()
        loadList()
      } else {
        message.error(res.data.message || '操作失败')
      }
    } catch (err) {
      message.error('操作失败')
    }
  }

  const columns = [
    {
      title: '标题',
      dataIndex: 'title',
      render: (t: string) => t || '-',
    },
    {
      title: '内容',
      dataIndex: 'content',
      render: (v: string) => v || '-',
      ellipsis: true,
    },
    {
      title: '申请人',
      dataIndex: 'employee',
      render: (emp: any) => emp?.real_name || '-',
    },
    {
      title: '状态',
      dataIndex: 'status',
      render: (v: number) => {
        const map: Record<number, { label: string; color: string }> = {
          0: { label: '待审批', color: 'orange' },
          1: { label: '已批准', color: 'green' },
          2: { label: '已拒绝', color: 'red' },
        }
        const s = map[v] || map[0]
        return <Tag color={s.color}>{s.label}</Tag>
      },
    },
    {
      title: '创建时间',
      dataIndex: 'created_at',
    },
    {
      title: '操作',
      key: 'action',
      render: (_: any, record: any) => record.status === 0 ? (
        <Space>
          <Button size="small" type="primary" icon={<CheckOutlined />} onClick={() => handleReview(record.id, 1)}>批准</Button>
          <Button size="small" danger icon={<CloseOutlined />} onClick={() => handleReview(record.id, 2)}>拒绝</Button>
        </Space>
      ) : '-',
    },
  ]

  return (
    <Card title={<><AuditOutlined /> 请假审批</>}>
      <Tabs activeKey={activeTab} onChange={setActiveTab} style={{ marginBottom: 16 }}>
        <Tabs.TabPane tab={`待审批 (${stats.pending || 0})`} key="pending" />
        <Tabs.TabPane tab={`已批准 (${stats.passed || 0})`} key="approved" />
        <Tabs.TabPane tab={`已拒绝 (${stats.rejected || 0})`} key="rejected" />
      </Tabs>
      <Table
        rowKey="id"
        columns={columns}
        dataSource={list}
        loading={loading}
        pagination={{ pageSize: 20, showTotal: (total: number) => `共 ${total} 条` }}
      />
    </Card>
  )
}

export default LeaveRequests
